
import Button from '@/components/NewUiElements/Buttons/Button'
import SectionLabel from '@/components/FileViewer/SectionLabel.vue'
import ChatIcon from '@/components/FileViewerModules/Chattable/ChatIcon.vue'

export default {
    name: 'DeleteChatRoom',
    components: {
        Button,
        SectionLabel,
        ChatIcon
    },
    props: {
        room: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data () {
        return {
            deleteForm: new this.$vForm()
        }
    },
    methods: {
        deleteRoom () {
            this.deleteForm.delete('/v1/chat-rooms/' + this.room.id)
                .then(res => {
                    this.$emit('chat-room-deleted', this.room)
                    this.$emit('close')
                })
        }
    }
}
